import {
  IonContent,
  IonPage,
  IonCard,
  IonRow,
  IonCol,
  IonImg,
} from '@ionic/react';
import React, { useEffect } from 'react';
import './Pay.css';

import GiftanoLogo from '../assets/images/giftano_white2.png';
import { customFetch, fetchIpInfo } from '../helpers/connection';

const NotFound: React.FC = () => {
  useEffect(() => {
    fetchIpInfo()
      .then((json) => {
        const ipAddress = json ? json.ip : '';
        return customFetch('/api/telemetry', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(ipAddress ? { 'X-Forwarded-For': ipAddress } : {}),
          },
          body: JSON.stringify({ p: window.location.pathname }),
        });
      })
      .catch((err) => {
        console.error('Failed to report to telemetry', err);
      });
  }, []);

  return (
    <IonPage>
      <IonContent className="with-bg">
        <IonCard>
          <IonRow>
            <IonCol
              size="auto"
              style={{ backgroundColor: 'var(--ion-color-primary)' }}
              className="side-col"
            >
              <div className="side-box">
                <a href="https://giftano.com">
                  <IonImg className="side-box-logo" src={GiftanoLogo}></IonImg>
                </a>
                <div className="side-box-footer">
                  <p>
                    Giftano.com{' '}
                    <a href="mailto:support@giftano.com" target="_blank" rel="noopener noreferrer">
                      support@giftano.com
                    </a>
                  </p>
                  <p>Giftano Pte Ltd 201433730C, One George Street Level 10 Singapore 049145</p>
                </div>
              </div>
            </IonCol>
            <IonCol style={{ padding: '15px 30px' }}>
              <div className="payment-step1">
                <h2 className="my-title">Payment to Giftano</h2>
                <h1 className="err-code">404</h1>
                <h1 className="err-message">PAGE NOT FOUND</h1>
              </div>
            </IonCol>
          </IonRow>
        </IonCard>
      </IonContent>
    </IonPage>
  );
};

export default NotFound;
